module.exports = __webpack_public_path__ + "media/images/proof_links/beru-6bbfa2ea63a9e91fa81dc2ad812fa23e.svg";